/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit, QueryList, ViewChild, ViewChildren
} from '@angular/core';

import { Logger                } from '@/util/logger';
import { MatSidenav }            from "@angular/material/sidenav";
import { first }                 from "rxjs/operators";
import { SortEvent }             from 'primeng/api';
import {
  Inplace,
  InplaceContent
}                                from "primeng/inplace";
import { IProjectRow }           from "@/screens/administration/i.project.row";
import { ProjectService }        from "@/services/project.service";
import {IOrganizationRow} from "@/screens/administration/i.organization.row";
import {OrganizationService} from "@/services/organization.service";

@Component({
  standalone: false,
  templateUrl: 'projects.list.component.html'
})

/**
 *
 * @class ProjectsListComponent
 *
 * @brief project management page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class ProjectsListComponent implements OnInit {

  @ViewChild('adminsidenav')
  public nav: MatSidenav;

  /** the list of CSV style entries for each project in the system */
  public projects: IProjectRow[] = [];

  /** the project key to use for creation */
  public prjCreateKey: string    = '';

  /** the project name to use for creation */
  public prjCreateName: string   = '';

  /** is the current key/project name valid for creating an project? */
  public prjInputValid: boolean  = false;

  /** the org selected in the org dropdown */
  public selectedOrg: number     = 0;

  /** all possible organizations */
  private organizations: IOrganizationRow[] = [];

  /** standard constructor */
  constructor(
    private prjservice: ProjectService,
    private orgservice: OrganizationService,
    private cdRef:  ChangeDetectorRef
  ) {


  }

  refresh() {

    let pl: ProjectsListComponent = this;

    Logger.debug(`[ProjectsListComponent] looking for projects...`);

    pl.prjservice.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          pl.projects = [];

          if (data.result) {

            data = data.result;
          }

          data.projects.forEach((item) => {

            pl.projects.push(item);

          });

          pl.cdRef.detectChanges();

          Logger.debug(`[ProjectsListComponent] projects: `, pl.projects);

        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not fetch project details: `, error);

        }

      });

    pl.orgservice.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          pl.organizations = [];

          if (data.result) {

            data = data.result;
          }

          pl.organizations.push({
            id: 0,
            name: 'None',
            key: 'None'
          });

          data.organizations.forEach((item) => {

            pl.organizations.push(item);

          });

          pl.cdRef.detectChanges();

          Logger.debug(`[ProjectsListComponent] organizations: `, pl.organizations);

        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not fetch organization details: `, error);

        }

      });
  }

  orgOptions(): IOrganizationRow[] {

    let pl: ProjectsListComponent = this;

    return pl.organizations;
  }

  orgChange(event) {

    let pl: ProjectsListComponent = this;

    Logger.debug("[ProjectsListComponent] new org: ", pl.selectedOrg);

    pl.checkKey();
  }

  /** on page setup */
  ngOnInit() {

    let pl: ProjectsListComponent = this;

    Logger.debug('[ProjectsListComponent] init...');

    pl.refresh();

  }

  /** check the "key" input for creating a project */
  checkKey(event = null) {

    let pl: ProjectsListComponent = this;

    let name: string = $(`#createproject`).val().toString().trim();
    let key: string = $(`#createprojectkey`).val().toString();

    /* clear the current error */

    pl.prjInputValid = true;
    $(`.prjcreateerror`).html('');

    /* they have to pick an org */

    if (pl.selectedOrg <= 0) {

      $(`.prjcreateerror`).html('Project must belong to an organization.');

      pl.prjInputValid = false;

      pl.cdRef.detectChanges();

      return false;
    }

    /* any validation issues? */

    if (!/^[a-zA-Z][_a-zA-Z0-9]+$/.test(key)) {

      $(`.prjcreateerror`).html('Project key must be of pattern [a-zA-Z][_a-zA-Z0-9]+');

      pl.prjInputValid = false;

      pl.cdRef.detectChanges();

      return false;
    }

    if (!name) {

      $(`.prjcreateerror`).html('Project name can not be empty.');

      pl.prjInputValid = false;

      pl.cdRef.detectChanges();

      return false;
    }

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key == 'Enter') {

        pl.createProject(true);
      }

    }

    /* clear to proceed! */

    pl.cdRef.detectChanges();

    return true;
  }

  clearPicker() {

    let pl: ProjectsListComponent = this;

    $(`#createproject`).val('');
    $(`#createprojectkey`).val('');

    pl.prjInputValid = false;
    pl.selectedOrg = 0;
  }

  createProject(noCheck: boolean  = false) {

    let pl: ProjectsListComponent = this;
    let name: string              = $(`#createproject`).val().toString();
    let key: string               = $(`#createprojectkey`).val().toString();
    let org: IOrganizationRow     = pl.organizations.find(x => x.id == pl.selectedOrg);

    if (!noCheck) {

      /* we haven't checked the values yet */

      if (!pl.checkKey()) {

        /* validation errors */

        return;
      }
    }

    pl.clearPicker();

    Logger.debug(`[ProjectsListComponent] creating new project: '${name}', '${key}'...`);

    pl.prjservice.create({name, key, rv_organizations_id: org.id})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          Logger.debug(`[ProjectsListComponent] project created, refreshing...`);

          pl.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not create project: `, error);
        }

      });

  }

  /** set a new name for the given project */
  savePrjName(id: number, name: string) {

    let pl: ProjectsListComponent = this;

    let prj: IProjectRow = pl.projects.find(x => x.id == id);

    if (!prj) {

      return ;
    }

    /* update locally */

    prj.name = name;

    /* update the database... */

    pl.prjservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          /* refresh the list ... */

          pl.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not save new project name: `, error);

        }

      });

  }

  prjEditKey(event, id: number, component: Inplace) {

    let pl: ProjectsListComponent = this;
    let value: string = $(`.prjclass-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[ProjectsListComponent] prj editor RETURN (${id}) => '${value}': `, event);

    pl.savePrjName(id, value);

  }

  prjEditDeactivate(id: number, component: Inplace) {

    let pl: ProjectsListComponent = this;
    let value: string = $(`.prjclass-${id} input`).val().toString();

    Logger.debug(`[ProjectsListComponent] deactivating prj editor (${id}) => '${value}': `, component);

    pl.savePrjName(id, value);

  }

  prjEditActivate(id: number, component: Inplace) {

    let ol: ProjectsListComponent = this;

    Logger.debug(`[ProjectsListComponent] activating prj editor (${id}): `, component);




  }

  /** check if an project is deletable */
  canDelete(id: number|string) {

    let pl: ProjectsListComponent = this;
    let prj: IProjectRow          = pl.projects.find(x => x.id == id);

    if (!prj) {

      return false;
    }

    let usage: number = prj.members.length;

    if (usage == 0) {

      return true;
    }

    /* still in use somewhere */

    return false;
  }

  /** soft delete a project */
  deleteProject(id: number|string) {

    let pl: ProjectsListComponent = this;

    Logger.debug(`[ProjectsListComponent] deleting: ${id} ...`);

    pl.prjservice.deleteProject(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: IProjectRow = data;

          let prj: IProjectRow = pl.projects.find(x => x.id == row.id);

          prj.is_deleted = true;

          pl.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not delete project: `, error);

        }

      });
  }

  /** undelete a project */
  unDeleteProject(id: number|string) {

    let pl: ProjectsListComponent = this;

    Logger.debug(`[ProjectsListComponent] activating: ${id} ...`);

    pl.prjservice.undeleteProject(id)
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          if (data.result) {

            data = data.result;
          }

          let row: IProjectRow = data;

          let prj: IProjectRow = pl.projects.find(x => x.id == row.id);

          prj.is_deleted = false;

          pl.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[ProjectsListComponent] could not delete project: `, error);

        }

      });


  }

  /** expand/collapse the sidebar navigation panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** helper to sort special rows like disk usage */
  tableSort(event: SortEvent) {

    let pl: ProjectsListComponent = this;

    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];

      /* deal with missing data */

      if (value1 == null && value2 != null) {

        return -1;

      } else if (value1 != null && value2 == null) {

        return 1;

      } else if (value1 == null && value2 == null) {

        return 0;
      }

      if (['id'].includes(event.field)) {

        /* straight number compare */

        return (parseFloat(value2) - parseFloat(value1)) * event.order;
      }

      if (['name', 'key'].includes(event.field)) {

        /* straight string compare */

        return (value1.toString().localeCompare(value2.toString())) * event.order;
      }

      if (event.field == 'created_at') {

        /* date compare */

        /* in some browsers the date format may not be 2025-01-05 11:30:10, it may be 01/05/2025 11:30:10 */

        if (/\//.test(value1)) {

          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[2], t1[0] - 1, t1[1], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :/]/);
          const d2 = new Date(Date.UTC(t2[2], t2[0] - 1, t2[1], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;

        } else {


          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[0], t1[1] - 1, t1[2], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :]/);
          const d2 = new Date(Date.UTC(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;
        }
      }

      /* can not interpret */

      return 0;
    });

    pl.cdRef.detectChanges();
  }

}
